import {getBackendURL, httpResponse, httpResponseError} from "../../fn";
import axios from "axios";

import {dealData} from "./deal";

/**
 * Поиск объекта по кадастровому номеру
 * @returns {Promise<UploadSigFileResult>}
 */
export const findRealtyWithCadnum = async (cadNum) => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/deal/find/realty/${cadNum}`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * Сохранить данные по недвиге
 * @returns {Promise<{data: *, ok: boolean}|{statusText: *, ok: boolean, message: string, status: *, errors: Array}>}
 */
export const saveRealtyData = async () => {
  const values = {...dealData.realty, address: dealData.realty.address};
  const result = await axios.put(`${getBackendURL()}/deal/${dealData.dealId}/realty/`, values, {
    withCredentials: true,
    headers: {
      'content-type': 'application/json',
    },
  })
    .then(function (response) {
      return httpResponse({})
    })
    .catch(function (error) {
      return httpResponseError(error)
    });
  return result;
}